/* eslint-disable jira/import-whitelist */
import { LOCAL } from '@atlassian/jira-cache/src/common/constants.tsx';
import createEntry from '@atlassian/jira-cache/src/common/utils/api/index.tsx';

const BOARD_ETAG_CACHE_NAMESPACE = 'board-etag';
const BOARD_ETAG_CACHE_SIZE = 10;
const BOARD_ETAG_CACHE_TTL = 1000 * 60 * 60 * 24; // 1 day expiry so that old values don't stay in the cache forever

export const boardEtagCache = createEntry<string>({
	size: BOARD_ETAG_CACHE_SIZE,
	cacheKey: BOARD_ETAG_CACHE_NAMESPACE,
	maxAge: BOARD_ETAG_CACHE_TTL,
	storageType: LOCAL,
});
